import { createFileRoute, useRouter } from "@tanstack/react-router";

import { parseCourseChecksSearch } from "@/features/orders";
import { CourseChecksPage } from "@/features/orders/pages";
import { strictSearch } from "@/shared/lib/search";

/** The courses ended early, and what their clients answered: under the orders, whose guard it has. */
export const Route = createFileRoute("/_app/orders/course-checks")({
  validateSearch: strictSearch(parseCourseChecksSearch),
  component: CourseChecks,
});

function CourseChecks() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const router = useRouter();
  return (
    <CourseChecksPage
      search={search}
      onSearchChange={(next, options) =>
        void navigate({ search: next, replace: options?.replace === true })
      }
      hrefOf={(orderId) =>
        router.buildLocation({ to: "/orders/$orderId", params: { orderId } }).href
      }
      onOpen={(orderId) => void router.navigate({ to: "/orders/$orderId", params: { orderId } })}
    />
  );
}
